<script>
    import Button from "./components/Button.svelte";

    let name = "";
    let email = "";
    let phone = "";
    let message = "";

    // This function will be called when the user submits the form or clicks a button
    async function postData(url = "", data = {}) {
        const response = await fetch(url, {
            method: "POST",
            mode: "no-cors",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data), // body data type must match "Content-Type" header
        });
        return response.body; // parses JSON response into native JavaScript objects
    }

    async function submitHandler() {
        try {
            const result = await postData(
                "https://tevcfme0e0.execute-api.us-east-2.amazonaws.com/dev/contact-us",
                {
                    fullName: name,
                    email,
                    phone,
                    message,
                },
            );
            console.log(result);
            alert("Your message has been sent!");
            window.location.reload();
        } catch (error) {
            console.error("Error:", error);
        }
    }
</script>

<main style="/*height: 100vh; overflow: hidden;*/">
    <div class="container-fluid" style="height: 100vh;">
        <div class="row" style="/*height: 100%; width: 100%;*/height: 100%;">
            <div
                class="col-6 pt-3"
                style="background-color: #2F2E41; color: #FFFFFF; "
            >
                <div class="row">
                    <div
                        class="col-1 d-flex justify-content-center align-items-center"
                    >
                        <a href="/">
                            <img
                                src="/assets/images/coming-soon-branding.png"
                                alt="Engage eSports"
                            />
                        </a>
                    </div>
                    <div
                        class="col-11 d-flex justify-content-start align-items-center inter-semibold"
                        style="font-size: 20;"
                    >
                        Engage Esports
                    </div>
                </div>
                <div class="container px-5">
                    <div class="container px-5">
                        <div class="row" style="height: 7rem"></div>
                        <div class="row">
                            <div
                                class="col-12 d-flex justify-content-start align-items-center"
                            >
                                <div class="row">
                                    <div
                                        class="col-12 d-flex justify-content-start align-items-center"
                                    >
                                        <h2>Site Coming Soon</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 pt-3 pb-4">
                                <div class="input-container">
                                    <input
                                        bind:value={name}
                                        type="text"
                                        placeholder="Enter your name"
                                    />
                                </div>
                            </div>
                            <div class="col-6 pb-4">
                                <div class="input-container">
                                    <input
                                        bind:value={email}
                                        type="email"
                                        placeholder="Enter your email address"
                                    />
                                </div>
                            </div>
                            <div class="col-6 pb-4">
                                <div class="input-container">
                                    <input
                                        bind:value={phone}
                                        type="tel"
                                        placeholder="Enter your phone number"
                                    />
                                </div>
                            </div>
                            <div class="col-12 pb-3">
                                <div class="input-container">
                                    <textarea
                                        bind:value={message}
                                        placeholder="How can we help you?"
                                        rows="12"
                                    ></textarea>
                                </div>
                            </div>
                            <div
                                class="col-12 d-flex justify-content-start align-items-center"
                            >
                                <Button
                                    text="Submit"
                                    customClass="submit-form"
                                    onClick={submitHandler}
                                >
                                    <img
                                        slot="posticon"
                                        src="/assets/images/right-arrow.png"
                                        alt=""
                                    />
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-6">
                <img
                    class="img-fluid"
                    src="/assets/images/coming-soon-image.png"
                    alt=""
                    style="height: 100%; width: 100%;"
                />
            </div>
        </div>
    </div>
</main>

<style>
    .input-container {
        /* border: 1px solid #555; */
        border-radius: 4px;
        /* display: flex;
        align-items: center; */
        /* overflow: hidden; */
        color: white !important;
    }

    .input-container input,
    .input-container textarea {
        padding-left: 1rem;
        border-top: none;
        border-right: none;
        border-bottom: none;
        border-left: 4px solid #31fab1;
        background: #383838;
        color: lightgrey !important;
        width: 100%;
    }

    .input-container input::placeholder,
    .input-container textarea::placeholder {
        color: lightgrey !important;
    }

    .input-container input:focus {
        outline: none;
    }

    /* .input-container::before {
        content: '>';
        color: #00FF7F;
        padding: 10px;
        background: #222;
        font-size: 16px;
        font-family: monospace;
    } */
</style>
